import { Button, Tooltip } from '@mui/material'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const TableFooterRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    padding: 8px 0;
`

export const TableFooter = styled.div`
    display: flex;
    flex-direction: column;
`

export const CorrectQtyPerBoxButton = styled(Button)`
    color: ${(props) => (props.disabled ? '' : theme.colors.blue)} !important;
    border-color: ${(props) => (props.disabled ? '' : theme.colors.blue)} !important;
    height: 100%;
`

export const CustomTooltip = styled(Tooltip)``
